import React from 'react'
import { Box } from '@mui/material'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import DashboardDatas from '../../components/dashboard/DashboardDatas'
import DashboardMapFilter from '../../components/dashboard/DashboardMapFilter'
import OrganizationInactiveTrackingPanel from '../../components/dashboard/OrganizationInactiveTrackingPanel'
import Footer from '../../components/common/Footer'
import { useUser } from '../login/UserContextPersistent'
import '../../components/dashboard/Dashboard.css'

export default function DashboardNew() {
  const { organizationInactive } = useUser()

  return (
    <Box className="dashboard-page-shell">
      <Box className="dashboard-page-shell-content">
        <TitleBar />
        <NavMenu/>
        <DashboardDatas/>
        {organizationInactive ? (
          <OrganizationInactiveTrackingPanel />
        ) : (
          <DashboardMapFilter dashboard />
        )}
      </Box>
      <Footer/>
    </Box>
  )
}
